import React from 'react';
import {DEFAULT_PAGE_SIZE} from './../config/constants';

export default function Paginator({onPage, meta}) {

  const renderPageLinks = () => {
    return meta.series?.map(p => (
      <li key={p} className={`page ${Number(p) === meta.page ? 'active' : ''}`}>
        <Page
          p={p}
          meta={meta}
          onClick={
            e => {
              if (p === 'gap' || p === meta.page) {
                return
              }
              onPage(p);
            }
        }>
          {p === 'gap' ? '...' : p}
        </Page>
      </li>
    ))
  };

  return (
    <div className="pagination-container bg-white">
      <span className="records px-3 mr-3 fs-10 weight-500 border-dark">
        {meta.from} - {meta.to} of {meta.count}
      </span>
      <nav aria-label="navigation">
        <ul className="pages pr-0 mb-0">
          <li className="page">
            <Page
              p={null}
              meta={meta}
              onClick={
                  e => {
                    if (meta.page === 1) {
                      return
                    }
                    onPage( (meta.page > 1 ? meta.page - 1 : 1) , DEFAULT_PAGE_SIZE)
                  }
            }>
              <span aria-hidden="true">&lsaquo;</span>
              <span className="visually-hidden">Previous</span>
            </Page>
          </li>
          {
            renderPageLinks()
          }
          <li className="page">
            <Page
              p={null}
              meta={meta}
              onClick={
                e => {
                  if (meta.page === meta.pages) {
                    return
                  }
                  onPage((meta.page < meta.pages ? meta.page + 1 : meta.pages), DEFAULT_PAGE_SIZE)
                }
            }>
              <span aria-hidden="true">&rsaquo;</span>
              <span className="visually-hidden">Next</span>
            </Page>
          </li>
        </ul>
      </nav>
    </div>
  );
};

const Page = ({p, meta, onClick, children}) => {
  return (
    <span
      className={`page-button ${p === 'gap' ? 'pagination-gap' : ''}`}
      onClick={onClick}
    >
      {children}
    </span>
  )
}